import React from 'react';
import FinancialGroupedBarChart from '@components/charts/FinancialGroupedBarChart';
import TrendsSection from './TrendsSection';
import ChartLegend from './ChartLegend';
import FinancialMatrixTable from './FinancialMatrixTable';
import type { FinancialSection } from '@app-types/performanceTrends';

export interface BalanceSheetSectionProps {
  data: FinancialSection;
}

/** Balance sheet section: 2-series grouped bar chart (Figma 3157:7983). */
const BalanceSheetSection: React.FC<BalanceSheetSectionProps> = ({ data }) => (
  <TrendsSection
    title={data.title}
    headerNodeId={data.headerNodeId}
    sectionNodeId={data.sectionNodeId}
    anchorId="balance"
  >
    <div className="trends-financial-chart">
      <FinancialGroupedBarChart
        data={data.chart}
        height={170}
        ariaLabel={`${data.title}のチャート`}
      />
      <ChartLegend series={data.legend} nodeId="3157:8543" />
    </div>
    <FinancialMatrixTable data={data.table} caption={data.title} />
  </TrendsSection>
);

export default BalanceSheetSection;
